// extracted by mini-css-extract-plugin
export var news_contents = "news-module--news_contents--2bsac";
export var news_contents__list = "news-module--news_contents__list--1MhRL";
export var news_contents__side = "news-module--news_contents__side--3yfOk";
export var news_contents__year = "news-module--news_contents__year--2Cr9b";
export var __current = "news-module--__current--38A1O";
export var list_rect__item = "news-module--list_rect__item--VnUM6";
export var news_side_box = "news-module--news_side_box--2GXbC";
export var news_link = "news-module--news_link--3XZQd";
export var news_link__wrap = "news-module--news_link__wrap--2-uf2";
export var news_link__title = "news-module--news_link__title--HqiwX";
export var news_date = "news-module--news_date--MZg4o";
export var news_detail_header = "news-module--news_detail_header--eF4Nl";
export var news_detail_header__head = "news-module--news_detail_header__head--1IeO_";
export var news_detail_header__title = "news-module--news_detail_header__title--2Ox0R";
export var news_detail_contents = "news-module--news_detail_contents--3dwjN";
export var news_sns = "news-module--news_sns--2tBmW";
export var news_sns__item = "news-module--news_sns__item--3uJ5U";
export var news_article = "news-module--news_article--2v0Wh";
export var note = "news-module--note--3gTcF";
export var col = "news-module--col--2RQcA";
export var col__fig = "news-module--col__fig--3fflP";
export var Thin = "news-module----thin--2PfdA";
export var col__text = "news-module--col__text--2p6pF";
export var btn = "news-module--btn--3TQ2W";
export var sectionTag = "news-module--section-tag--38e5u";